module.exports = __webpack_public_path__ + "static/media/member1.ca6b6cc3.jpg";